import React, { useEffect } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import DashboardSolicitudes from './Solicitudes/DashboardSolicitudesAdmin';
import { useSolicitudesDisponiblesModel } from '../../modelos/Solicitudes/modeloSolicitudes';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';

const DashboardAdminAdmin = () => {
  const navigate = useNavigate();
  const{
    solicitudesDisponibles,
    loadingSolicitudes,
    errorSolicitudes,
    cargarSolicitudes,
    setupWebSocketsSolicitudes,
  } = useSolicitudesDisponiblesModel();

  const {loadingConfiguracion} = useConfiguracion()
  
  useEffect(() => {
    cargarSolicitudes(true);

    
     const cleanupWebSockets = setupWebSocketsSolicitudes();

     return () => {
      cleanupWebSockets();
    };
    
  }, []);

  //Refrescaar las solicitudes
  const handleRefrescar = () => {
    cargarSolicitudes(true);
  };

  //Cargando configuracion
  if(loadingConfiguracion){
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-blue-500 border-r-transparent"></div>
          <p className="mt-2 text-gray-600">Cargando Configuracion...</p>
        </div>
      </div>
    );
  }

  if (errorSolicitudes ) {
    return (
      <div className="text-center p-4 text-red-500">
        Error al cargar las solicitudes: {errorSolicitudes}
      </div>
    );
  }

  return (
    <DashboardSolicitudes
      solicitudes={solicitudesDisponibles}
      loading = {loadingSolicitudes}
      onRefrescar={handleRefrescar}
    />
  );
};

export default DashboardAdminAdmin;